// extracted by mini-css-extract-plugin
module.exports = {"disabled":"ButtonIconPrimary_disabled__eXHah","inverse":"ButtonIconPrimary_inverse__yhiKn","default":"ButtonIconPrimary_default__RUW29"};